export default __webpack_public_path__ + "static/media/streamer-heading.3af38c86.png";